import { useState } from "react";
import { loginJugador } from "../services/api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../styles/login.css";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

const handleSubmit = async (e) => {
  e.preventDefault();
  setError(""); // Limpia el error anterior
  try {
    const res = await loginJugador(form);
    login(res.data.token, res.data.rol); // Guarda el token y el rol en el contexto

    // Redirige según el rol
    if (res.data.rol === "admin") {
      navigate("/admin/panel");
    } else {
      navigate("/perfil");
    }
  } catch (err) {
    setError("Datos inválidos o contraseña incorrecta");
  }
};

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Iniciar Sesion</h2>
        {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
        <input placeholder="Email" onChange={e => setForm({ ...form, email: e.target.value })} required />
        <input type="password" placeholder="Contraseña" onChange={e => setForm({ ...form, password: e.target.value })} required />
        <a href="/registro">Registrarse</a>
        <button type="submit">Iniciar sesión</button>
      </form>
    </div>
  );
}